module.exports = __webpack_public_path__ + "img/icon_success.742b5443.png";